import { render, staticRenderFns } from "./TabelHeader.vue?vue&type=template&id=6aa0f987&"
import script from "./TabelHeader.vue?vue&type=script&lang=js&"
export * from "./TabelHeader.vue?vue&type=script&lang=js&"
import style0 from "./TabelHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aa0f987')) {
      api.createRecord('6aa0f987', component.options)
    } else {
      api.reload('6aa0f987', component.options)
    }
    module.hot.accept("./TabelHeader.vue?vue&type=template&id=6aa0f987&", function () {
      api.rerender('6aa0f987', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DeliveryNote/DnbarcodeHandmadeOutBox/components/TabelHeader.vue"
export default component.exports